/**
 * Common types used across the application
 */

/**
 * Common color designations for UI components
 */
type ColorVariant = "danger" | "warning" | "primary" | "success" | "default";

// Common type definitions that can be used in client components
// These are string literals that match the Prisma enums but don't require Prisma imports

export type UserRole =
  | "organization_admin"
  | "executive_admin"
  | "coordinator"
  | "case_worker"
  | "volunteer";

export type NeedStatus =
  | "open"
  | "claimed"
  | "completed"
  | "expired"
  | "pending_claim"
  | "canceled"
  | "denied";

export type NeedUrgency = "low" | "medium" | "high" | "critical";

/**
 * Status color mapping for consistent UI
 */
export const StatusColors: Record<NeedStatus, ColorVariant> = {
  canceled: "danger",
  claimed: "primary",
  completed: "success",
  denied: "danger",
  expired: "danger",
  open: "success",
  pending_claim: "warning",
};

/**
 * Urgency color mapping for consistent UI
 */
export const UrgencyColors: Record<NeedUrgency, ColorVariant> = {
  critical: "danger",
  high: "warning",
  low: "success",
  medium: "primary",
};

/**
 * Helper for capitalizing the first letter of a string
 */
export function capitalizeFirstLetter(text: string): string {
  if (!text) return "";

  return text.charAt(0).toUpperCase() + text.slice(1);
}

// Note: Date formats have been moved to ui.ts to centralize UI-related types
// and avoid duplicate exports

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  active: boolean;
  organizationId: string;
  createdAt: Date;
  updatedAt: Date;
}
